/* ==========================================================================
   LVLY Gift Builder — Quiz logic, scoring, cart
   ========================================================================== */
(function(){
  'use strict';

  // Parse Liquid-injected data
  var dataEl = document.getElementById('gift-builder-data');
  if(!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  var FLOWERS = (DATA.flowers || []).filter(function(x){ return x != null; });
  var ADDONS = (DATA.addons || []).filter(function(x){ return x != null; });
  var OCCASIONS = (DATA.occasions || []).filter(function(x){ return x != null; });

  // Parse jar collections — filter nulls from each
  var JAR_COLLECTIONS = {};
  if(DATA.jarCollections){
    Object.keys(DATA.jarCollections).forEach(function(k){
      JAR_COLLECTIONS[k] = (DATA.jarCollections[k] || []).filter(function(x){ return x != null; });
    });
  }

  // Filter null from variant arrays too
  FLOWERS.forEach(function(f){
    if(f.variants) f.variants = f.variants.filter(function(v){ return v != null; });
  });

  // State
  var A = {}; // answers: { '1': occasion, '2': [loves], '3': budget }
  var selFlower = null; // flower handle
  var selVariantIdx = 0;
  var selAddons = []; // addon handles
  var selJar = null; // selected jar object {variantId, price, isPersonalised}
  var selJarMessage = ''; // personalisation text

  function q(id){ return document.getElementById(id); }

  // ── Occasion labels for display ──
  var OCC_LABELS = {
    birthday:'a birthday', love:'a romantic occasion', sympathy:'thinking of you',
    congratulations:'congratulations', thank_you:'a thank you', just_because:'just because'
  };

  // ── Tag helpers ──
  function hasTag(tags, tag){
    if(!tags) return false;
    for(var i=0;i<tags.length;i++){
      if(tags[i].toLowerCase() === tag.toLowerCase()) return true;
    }
    return false;
  }

  function getAddonCategories(addon){
    // Returns array of all matching categories for this addon
    var cats = [];
    var tags = addon.tags || [];
    for(var i=0;i<tags.length;i++){
      var t = tags[i].toLowerCase();
      if(t === 'tag:chocaddon' || t === 'chocaddon') cats.push('chocolate');
      if(t === 'tag:sweettreats' || t === 'sweettreats') cats.push('chocolate');
      if(t === 'tag:drinks' || t === 'drinks') cats.push('wine');
      if(t === 'tag:pamper' || t === 'pamper') cats.push('pamper');
      if(t === 'tag:food' || t === 'food') cats.push('hosting');
      if(t === 'tag:baby' || t === 'baby') cats.push('baby');
      if(t === 'tag:kids' || t === 'kids') cats.push('kids');
      if(t === 'tag:personalisedgifts' || t === 'personalisedgifts') cats.push('personalised');
    }
    // Deduplicate
    var unique = [];
    for(var j=0;j<cats.length;j++){
      if(unique.indexOf(cats[j]) === -1) unique.push(cats[j]);
    }
    return unique.length > 0 ? unique : ['other'];
  }

  function getAddonPrimaryCategory(addon){
    var cats = getAddonCategories(addon);
    return cats[0] || 'other';
  }

  function addonHasCategory(addon, cat){
    return getAddonCategories(addon).indexOf(cat) > -1;
  }

  function isSoldOut(addon){
    return /sold\s*out/i.test(addon.title);
  }

  // ── Price helpers (Shopify prices are in cents) ──
  function centsToDisplay(cents){ return '$' + (cents / 100).toFixed(0); }
  function centsToDollars(cents){ return cents / 100; }

  // ══════════════════════════════════════════════════════════════════════════
  // STEP 1: OCCASION GRID
  // ══════════════════════════════════════════════════════════════════════════
  function buildOccasionGrid(){
    var grid = q('gb-occ-grid');
    if(!grid) return;
    grid.innerHTML = '';
    OCCASIONS.forEach(function(occ){
      var card = document.createElement('div');
      card.className = 'gb-occ-card';

      if(occ.image){
        var img = document.createElement('img');
        img.src = occ.image; img.className = 'gb-occ-img'; img.alt = occ.label;
        img.onerror = function(){
          this.style.display='none';
          var ph = document.createElement('div');
          ph.className = 'gb-occ-ph'; ph.textContent = occ.emoji || '🌸';
          card.insertBefore(ph, card.querySelector('.gb-occ-overlay'));
        };
        card.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.className = 'gb-occ-ph'; ph.textContent = occ.emoji || '🌸';
        card.appendChild(ph);
      }

      var overlay = document.createElement('div'); overlay.className = 'gb-occ-overlay';
      var lw = document.createElement('div'); lw.className = 'gb-occ-label-wrap';
      var lb = document.createElement('div'); lb.className = 'gb-occ-label';
      lb.innerHTML = '<span>'+occ.label+'</span><div class="gb-occ-tick"><div class="gb-occ-tick-dot"></div></div>';
      lw.appendChild(lb); overlay.appendChild(lw); card.appendChild(overlay);

      card.addEventListener('click', function(){
        document.querySelectorAll('.gb-occ-card').forEach(function(c){c.classList.remove('sel');});
        card.classList.add('sel');
        A['1'] = occ.value;
        setTimeout(function(){ nextStep(1); }, 220);
      });
      grid.appendChild(card);
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // STEP 2 & 3: TILE SELECTIONS
  // ══════════════════════════════════════════════════════════════════════════
  document.querySelectorAll('.gb-opt-tile').forEach(function(btn){
    btn.addEventListener('click', function(){
      var step = this.dataset.step;
      var stepNum = parseInt(step);

      if(stepNum === 2){
        // Multi-select for loves
        this.classList.toggle('sel');
        var selected = [];
        document.querySelectorAll('.gb-opt-tile[data-step="2"].sel').forEach(function(b){
          selected.push(b.dataset.val);
        });
        A['2'] = selected.length > 0 ? selected : null;
        var nb = q('gb-loves-continue');
        if(nb) nb.classList.toggle('on', selected.length > 0);
      } else {
        // Single-select for budget — auto-advance
        document.querySelectorAll('.gb-opt-tile[data-step="'+step+'"]').forEach(function(b){b.classList.remove('sel');});
        this.classList.add('sel');
        A[step] = this.dataset.val;
        setTimeout(function(){ buildBundle(); }, 220);
      }
    });
  });

  // ══════════════════════════════════════════════════════════════════════════
  // PROGRESS BAR
  // ══════════════════════════════════════════════════════════════════════════
  function setProgress(pct){
    var fill=q('gb-prog'); if(fill) fill.style.width=pct+'%';
    var step=Math.round(pct/33.33)+1; if(step>3)step=3; if(step<1)step=1;
    var pn=q('gb-prog-num'); if(pn) pn.textContent='Step '+step+' of 3';
    ['gb-ps1','gb-ps2','gb-ps3'].forEach(function(id,i){
      var el=q(id); if(el) el.classList.toggle('active', i<step);
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // NAVIGATION
  // ══════════════════════════════════════════════════════════════════════════
  window.gbNextStep = function(from){
    q('gb-s'+from).classList.remove('active');
    q('gb-s'+(from+1)).classList.add('active');
    setProgress((from/3)*100);
    window.scrollTo(0,0);
  };
  window.gbGoBack = function(from){
    q('gb-s'+from).classList.remove('active');
    q('gb-s'+(from-1)).classList.add('active');
    setProgress(((from-2)/3)*100);
    window.scrollTo(0,0);
  };
  // Expose for inline onclick
  window.nextStep = window.gbNextStep;
  window.goBack = window.gbGoBack;

  // ══════════════════════════════════════════════════════════════════════════
  // FLOWER PICKING LOGIC
  // ══════════════════════════════════════════════════════════════════════════
  function isSympathyFlower(f){
    return hasTag(f.tags, 'collection-add-ons-sympathy');
  }

  function getFlowerByHandle(handle){
    for(var i=0;i<FLOWERS.length;i++){
      if(FLOWERS[i].handle === handle) return FLOWERS[i];
    }
    return null;
  }

  function pickFlower(){
    var budget = A['3'], occ = A['1'], loves = A['2'];
    var budgetCaps = {under100:10000, '100to150':15000, '150to200':20000, over200:999900};
    var cap = budgetCaps[budget] || 999900;

    // Filter available flowers
    var pool = FLOWERS.filter(function(f){
      if(!f.variants || f.variants.length === 0) return false;
      if(occ === 'sympathy' && !isSympathyFlower(f)) return false;
      if(occ !== 'sympathy' && isSympathyFlower(f)) return false;
      // Long stem roses only for "sending love"
      if(/long\s*stem\s*rose/i.test(f.title) && occ !== 'love') return false;
      // At least one variant must be under the budget cap
      var minPrice = f.variants[0].price;
      for(var i=1;i<f.variants.length;i++){
        if(f.variants[i].price < minPrice) minPrice = f.variants[i].price;
      }
      return minPrice <= cap;
    });

    if(pool.length === 0) pool = FLOWERS.filter(function(f){ return f.variants && f.variants.length > 0; });

    // Score flowers
    var lovesArr = Array.isArray(loves) ? loves : (loves ? [loves] : []);
    var isFlowersAboveAll = lovesArr.length === 1 && lovesArr[0] === 'flowers';

    var scored = pool.map(function(f){
      var s = 0;
      var minPrice = f.variants[0].price;

      // Prefer flowers that leave room for add-ons (unless flowers-above-all)
      if(!isFlowersAboveAll){
        if(minPrice <= cap * 0.6) s += 3;
        else if(minPrice <= cap * 0.8) s += 1;
      } else {
        // For flowers-above-all, prefer premium
        if(minPrice > cap * 0.5) s += 3;
      }

      // Budget-specific preferences
      if(budget === 'under100' && minPrice <= 8000) s += 2;
      if(budget === '100to150' && minPrice >= 7000 && minPrice <= 11000) s += 2;
      if(budget === '150to200' && minPrice >= 9000) s += 2;
      if(budget === 'over200' && minPrice >= 12000) s += 3;

      // Occasion-specific tag boosts
      if(occ === 'love' && hasTag(f.tags, 'anniversary')) s += 5;

      // Slight randomness
      s += Math.random() * 0.5;
      return {flower: f, score: s};
    });

    scored.sort(function(a,b){ return b.score - a.score; });
    return scored[0] ? scored[0].flower.handle : (pool[0] ? pool[0].handle : FLOWERS[0].handle);
  }

  // ══════════════════════════════════════════════════════════════════════════
  // ADDON PICKING LOGIC
  // ══════════════════════════════════════════════════════════════════════════
  function pickAddons(){
    var loves = A['2'], occ = A['1'], budget = A['3'];
    var lovesArr = Array.isArray(loves) ? loves : (loves ? [loves] : []);

    // Flowers above all — no add-ons
    if(lovesArr.length === 1 && lovesArr[0] === 'flowers') return [];

    var budgetCaps = {under100:10000, '100to150':15000, '150to200':20000, over200:999900};
    var cap = budgetCaps[budget] || 999900;
    var flower = getFlowerByHandle(selFlower);
    var flowerPrice = flower ? flower.variants[selVariantIdx].price : 7000;
    var remaining = cap - flowerPrice;
    var maxAddons = budget === 'under100' ? 1 : budget === '100to150' ? 2 : 3;

    // Occasion-specific keywords — exclude addons that mention another occasion in title
    var occKeywords = {
      birthday: /\bbirth\s*day\b/i,
      sympathy: /\bsympathy\b|\bthinking\s*of\s*you\b|\bcondolence/i,
      congratulations: /\bcongrat/i,
      love: /\bvalentine/i,
      thank_you: /\bthank\s*you\b/i
    };

    // Filter pool — remove sold out, over budget, kids/baby, wrong-occasion items
    var pool = ADDONS.filter(function(a){
      if(a.price > remaining) return false;
      if(isSoldOut(a)) return false;
      if(addonHasCategory(a, 'baby') || addonHasCategory(a, 'kids')) return false;
      // Exclude addons that are clearly for a different occasion
      for(var occKey in occKeywords){
        if(occKey !== occ && occKeywords[occKey].test(a.title)) return false;
      }
      return true;
    });

    // Score — loves selection is the primary signal (very high weight)
    var scored = pool.map(function(a){
      var s = 0;

      // ── LOVES MATCH (highest weight: +15) ──
      // This is what the customer explicitly asked for
      if(lovesArr.indexOf('chocolate') > -1 && addonHasCategory(a, 'chocolate')) s += 15;
      if(lovesArr.indexOf('wine') > -1 && addonHasCategory(a, 'wine')) s += 15;
      if(lovesArr.indexOf('pamper') > -1 && addonHasCategory(a, 'pamper')) s += 15;
      if(lovesArr.indexOf('hosting') > -1 && addonHasCategory(a, 'hosting')) s += 15;
      if(lovesArr.indexOf('all') > -1) s += 3;

      // Penalise items that DON'T match any loves category (unless "all")
      if(lovesArr.indexOf('all') === -1){
        var matchesAnyLove = false;
        var lovesCatMap = {chocolate:'chocolate', wine:'wine', pamper:'pamper', hosting:'hosting'};
        lovesArr.forEach(function(l){
          var mapped = lovesCatMap[l];
          if(mapped && addonHasCategory(a, mapped)) matchesAnyLove = true;
        });
        if(!matchesAnyLove) s -= 5;
      }

      // ── OCCASION BOOST (+5) ──
      if(occ === 'birthday' && addonHasCategory(a, 'chocolate')) s += 5;
      if(occ === 'sympathy' && addonHasCategory(a, 'pamper')) s += 5;
      if(occ === 'thank_you' && addonHasCategory(a, 'pamper')) s += 4;
      if(occ === 'congratulations' && addonHasCategory(a, 'wine')) s += 5;
      if(occ === 'love' && addonHasCategory(a, 'wine')) s += 5;
      if(occ === 'just_because' && addonHasCategory(a, 'chocolate')) s += 3;

      // ── BUDGET FILL (+1 to +3) — prefer addons that use the budget well ──
      if(budget === '100to150' && a.price >= 2500) s += 1;
      if(budget === '150to200' && a.price >= 3500) s += 2;
      if(budget === 'over200' && a.price >= 5000) s += 3;

      // ── Alcohol product detection for diversity limit ──
      var isAlcohol = hasTag(a.tags, 'product:alc') || /prosecco|champagne|mo[eë]t|wine|martini/i.test(a.title);

      // Tiny randomness to break ties
      s += Math.random() * 0.3;
      return {addon: a, score: s, primaryCat: getAddonPrimaryCategory(a), isAlcohol: isAlcohol};
    });

    scored.sort(function(a,b){ return b.score - a.score; });

    // Pick with diversity — relax duplicate-category and alcohol limits for high budgets
    var highBudget = (budget === '150to200' || budget === 'over200');
    var maxAlcohol = highBudget ? 2 : 1;
    var maxPerCat = highBudget ? 2 : 1;
    var picked = [], catCounts = {}, alcoholCount = 0, runningTotal = 0;
    for(var i = 0; i < scored.length; i++){
      if(picked.length >= maxAddons) break;
      var item = scored[i];
      if(runningTotal + item.addon.price > remaining) continue;
      // Alcohol limit
      if(item.isAlcohol && alcoholCount >= maxAlcohol) continue;
      // Category diversity — allow up to maxPerCat per category, but still prefer variety when slots remain
      var catCount = catCounts[item.primaryCat] || 0;
      if(catCount >= maxPerCat) continue;
      if(catCount >= 1 && picked.length < maxAddons - 1 && !highBudget) continue;
      picked.push(item.addon);
      catCounts[item.primaryCat] = catCount + 1;
      if(item.isAlcohol) alcoholCount++;
      runningTotal += item.addon.price;
    }

    // If we didn't fill all slots (diversity filter was too strict), do a second pass
    if(picked.length < maxAddons){
      for(var j = 0; j < scored.length; j++){
        if(picked.length >= maxAddons) break;
        var item2 = scored[j];
        var alreadyPicked = false;
        for(var k=0;k<picked.length;k++){ if(picked[k].handle === item2.addon.handle){ alreadyPicked = true; break; }}
        if(alreadyPicked) continue;
        if(runningTotal + item2.addon.price > remaining) continue;
        if(item2.isAlcohol && alcoholCount >= maxAlcohol) continue;
        picked.push(item2.addon);
        runningTotal += item2.addon.price;
        if(item2.isAlcohol) alcoholCount++;
      }
    }
    return picked;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // EXPERT QUOTE
  // ══════════════════════════════════════════════════════════════════════════
  // Quote templates: {{flower}}, {{addon}}, {{addon2}}, {{addon3}}, {{allAddons}}
  var QUOTES = {
    birthday: {
      single: [
        "{{flower}} and {{addon}}? That's basically a birthday party in a box.",
        "Nothing says 'happy birthday, you legend' quite like {{flower}} with a side of {{addon}}.",
        "Birthday sorted. {{flower}} and {{addon}} is the combo they didn't know they needed."
      ],
      multi: [
        "{{flower}}, {{addon}} AND {{addon2}}? You're not just giving a gift, you're giving a whole birthday experience.",
        "{{flower}} with {{addon}} and {{addon2}} — they'll be bragging about this gift for weeks.",
        "{{addon}}, {{addon2}} and {{flower}} all in one bundle? You just out-gifted everyone at the party."
      ]
    },
    love: {
      single: [
        "{{flower}} and {{addon}}? Cupid called — he's taking notes.",
        "Romance level: expert. {{flower}} with {{addon}} is *the* move.",
        "{{flower}} paired with {{addon}} — that's romance done right."
      ],
      multi: [
        "{{flower}}, {{addon}} and {{addon2}}? If this doesn't say 'I love you', nothing will.",
        "{{addon}} and {{addon2}} alongside {{flower}} — you clearly know the way to someone's heart.",
        "{{flower}} with {{addon}} and {{addon2}}? This bundle is basically a love letter in a box."
      ]
    },
    sympathy: {
      single: [
        "{{flower}} with {{addon}} — a really thoughtful way to let them know you care.",
        "Sometimes the right gift says what words can't. This is one of those.",
        "You've put real thought into this. {{flower}} with {{addon}} is perfect."
      ],
      multi: [
        "{{flower}} with {{addon}} and {{addon2}} — such a gentle, beautiful way to show you're thinking of them.",
        "{{addon}} and {{addon2}} alongside {{flower}} — this is a really lovely way to wrap up a hug and send it their way.",
        "Every piece of this bundle — {{flower}}, {{addon}}, {{addon2}} — says 'I'm here for you'."
      ]
    },
    congratulations: {
      single: [
        "{{flower}} and {{addon}}? Now that's a celebration waiting to happen.",
        "Big moment deserves a big gift. {{flower}} + {{addon}} absolutely nails it.",
        "Pop the confetti — {{flower}} with {{addon}} is the ultimate congrats combo."
      ],
      multi: [
        "{{flower}}, {{addon}} and {{addon2}}? That's not just congratulations, that's a standing ovation.",
        "{{addon}} and {{addon2}} with {{flower}} — they did something amazing and you've matched the energy perfectly.",
        "{{flower}} plus {{addon}} and {{addon2}}? This bundle screams 'you're incredible and I'm so proud of you'."
      ]
    },
    thank_you: {
      single: [
        "{{flower}} and {{addon}}? That's a thank you they'll actually remember.",
        "Forget the generic card — {{flower}} with {{addon}} says it way better.",
        "{{flower}} paired with {{addon}} — they'll be thanking *you* right back."
      ],
      multi: [
        "{{flower}} with {{addon}} and {{addon2}}? You've just set a new standard for thank you gifts.",
        "{{addon}}, {{addon2}} and {{flower}} — gratitude has never looked this gorgeous.",
        "{{flower}}, {{addon}} and {{addon2}} all in one? That's not a thank you, that's a mic drop."
      ]
    },
    just_because: {
      single: [
        "No reason needed. {{flower}} and {{addon}} is just pure joy in a bundle.",
        "The best gifts are the unexpected ones. {{flower}} + {{addon}}? Nailed it.",
        "{{flower}} and {{addon}} on a random Tuesday? You're officially their favourite person."
      ],
      multi: [
        "{{flower}}, {{addon}} and {{addon2}} — just because? More like just brilliant.",
        "No occasion, no reason, just {{flower}} with {{addon}} and {{addon2}}. Absolute legend move.",
        "{{flower}} plus {{addon}} and {{addon2}} out of nowhere? Surprise-level: legendary."
      ]
    }
  };

  function getAddonTitle(handle){
    for(var i=0;i<ADDONS.length;i++){
      if(ADDONS[i].handle === handle) return ADDONS[i].title;
    }
    return null;
  }

  function generateQuote(flower, addons, occasion){
    var occQuotes = QUOTES[occasion] || QUOTES['just_because'];
    var pool = (addons.length >= 2 && occQuotes.multi) ? occQuotes.multi : occQuotes.single;
    var template = pool[Math.floor(Math.random() * pool.length)];

    var flowerName = flower ? flower.title : 'these gorgeous flowers';
    var a1 = addons.length > 0 ? (getAddonTitle(addons[0]) || 'a little something extra') : 'a little something extra';
    var a2 = addons.length > 1 ? (getAddonTitle(addons[1]) || '') : '';
    var a3 = addons.length > 2 ? (getAddonTitle(addons[2]) || '') : '';

    var quote = template
      .replace(/\{\{flower\}\}/g, flowerName)
      .replace(/\{\{addon\}\}/g, a1)
      .replace(/\{\{addon2\}\}/g, a2)
      .replace(/\{\{addon3\}\}/g, a3);
    return quote;
  }

  function renderQuote(flower, addons, occasion){
    var el = q('gb-quote');
    if(!el) return;
    var text = generateQuote(flower, addons, occasion);
    el.innerHTML = '\u201C' + text + '\u201D<div class="gb-quote-attr">\u2014 Hannah, LVLY</div>';
  }

  // ══════════════════════════════════════════════════════════════════════════
  // BUILD BUNDLE (show result)
  // ══════════════════════════════════════════════════════════════════════════
  window.buildBundle = function(){
    q('gb-s3').classList.remove('active');
    q('gb-s-result').classList.add('active');
    setProgress(100);
    window.scrollTo(0,0);

    selFlower = pickFlower();
    selVariantIdx = 0;
    var f = getFlowerByHandle(selFlower);
    if(!f) return;

    renderFlower(f);
    selJar = null; selJarMessage = '';
    renderJars();
    selAddons = pickAddons().map(function(a){ return a.handle; });
    renderAddons();
    renderQuote(f, selAddons, A['1']);
    updateTotal();
  };

  function renderFlower(f){
    var wrap = q('gb-flower-img-wrap');
    wrap.innerHTML = '<img class="gb-flower-img" src="'+f.image+'" alt="'+f.title+'" onerror="this.style.display=\'none\'">';
    q('gb-flower-name').textContent = f.title;
    q('gb-flower-price').textContent = 'From ' + centsToDisplay(f.variants[0].price);

    var varRow = q('gb-var-row');
    varRow.innerHTML = '';
    if(f.variants.length > 1){
      varRow.style.display = '';
      f.variants.forEach(function(v, i){
        var b = document.createElement('button');
        b.className = 'gb-var-pill' + (i === 0 ? ' sel' : '');
        b.textContent = v.title + ' — ' + centsToDisplay(v.price);
        b.onclick = function(){
          document.querySelectorAll('.gb-var-pill').forEach(function(x){ x.classList.remove('sel'); });
          b.classList.add('sel');
          selVariantIdx = i;
          updateTotal();
        };
        varRow.appendChild(b);
      });
    } else {
      varRow.style.display = 'none';
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // DRAG-TO-SCROLL HELPER
  // ══════════════════════════════════════════════════════════════════════════
  function enableDragScroll(el){
    var isDown = false, startX, scrollLeft, hasDragged;
    el.addEventListener('mousedown', function(e){
      isDown = true; hasDragged = false;
      el.classList.add('gb-dragging');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      e.preventDefault();
    });
    el.addEventListener('mouseleave', function(){ isDown = false; el.classList.remove('gb-dragging'); });
    el.addEventListener('mouseup', function(){ isDown = false; el.classList.remove('gb-dragging'); });
    el.addEventListener('mousemove', function(e){
      if(!isDown) return;
      var x = e.pageX - el.offsetLeft;
      var walk = x - startX;
      if(Math.abs(walk) > 3) hasDragged = true;
      el.scrollLeft = scrollLeft - walk;
    });
    // Prevent click on jar card if user was dragging
    el.addEventListener('click', function(e){
      if(hasDragged){ e.stopPropagation(); hasDragged = false; }
    }, true);
  }

  // ══════════════════════════════════════════════════════════════════════════
  // JAR PICKER
  // ══════════════════════════════════════════════════════════════════════════
  function getFlowerJarTag(f){
    if(!f || !f.tags) return null;
    var jarTags = ['ft:4_jars','ft:5_jars','ft:6_jars'];
    for(var i=0;i<f.tags.length;i++){
      var t = f.tags[i].toLowerCase();
      for(var j=0;j<jarTags.length;j++){
        if(t === jarTags[j]) return jarTags[j];
      }
    }
    return null;
  }

  function isPersonalisedJar(jar){
    return hasTag(jar.tags, 'product:personalised');
  }

  function renderJars(){
    var block = q('gb-jar-block');
    var list = q('gb-jar-list');
    var persSection = q('gb-jar-personalise');
    if(!block || !list) return;

    var f = getFlowerByHandle(selFlower);
    var jarTag = getFlowerJarTag(f);

    if(!jarTag || !JAR_COLLECTIONS[jarTag] || JAR_COLLECTIONS[jarTag].length === 0){
      block.style.display = 'none';
      selJar = null;
      selJarMessage = '';
      return;
    }

    block.style.display = '';
    list.innerHTML = '';
    var jars = JAR_COLLECTIONS[jarTag];

    // Pre-select first jar
    if(!selJar || !jars.some(function(j){ return j.variantId === selJar.variantId; })){
      selJar = {variantId: jars[0].variantId, price: jars[0].price, isPersonalised: isPersonalisedJar(jars[0])};
    }

    jars.forEach(function(jar){
      var card = document.createElement('div');
      var isSel = selJar && selJar.variantId === jar.variantId;
      card.className = 'gb-jar-card' + (isSel ? ' sel' : '');

      var img = document.createElement('img');
      img.src = jar.image; img.className = 'gb-jar-card-img'; img.alt = jar.title;
      img.onerror = function(){ this.style.display = 'none'; };
      card.appendChild(img);

      var title = document.createElement('div');
      title.className = 'gb-jar-card-title'; title.textContent = jar.title;
      card.appendChild(title);

      if(jar.price > 0){
        var price = document.createElement('div');
        price.className = 'gb-jar-card-price'; price.textContent = '+ ' + centsToDisplay(jar.price);
        card.appendChild(price);
      }

      card.addEventListener('click', function(){
        selJar = {variantId: jar.variantId, price: jar.price, isPersonalised: isPersonalisedJar(jar)};
        document.querySelectorAll('.gb-jar-card').forEach(function(c){ c.classList.remove('sel'); });
        card.classList.add('sel');
        // Show/hide personalisation input
        if(selJar.isPersonalised){
          persSection.style.display = '';
        } else {
          persSection.style.display = 'none';
          selJarMessage = '';
          var inp = q('gb-jar-input'); if(inp) inp.value = '';
        }
        updateTotal();
      });

      list.appendChild(card);
    });

    // Enable drag-to-scroll on jar list
    enableDragScroll(list);

    // Show/hide personalisation based on current selection
    if(selJar.isPersonalised){
      persSection.style.display = '';
    } else {
      persSection.style.display = 'none';
    }

    // Listen for input changes
    var inp = q('gb-jar-input');
    if(inp){
      inp.oninput = function(){ selJarMessage = this.value; };
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER ADDONS
  // ══════════════════════════════════════════════════════════════════════════
  function renderAddons(){
    var grid = q('gb-addon-grid');
    if(!grid) return;
    grid.innerHTML = '';

    var lovesArr = Array.isArray(A['2']) ? A['2'] : (A['2'] ? [A['2']] : []);
    var isFlowersAboveAll = lovesArr.length === 1 && lovesArr[0] === 'flowers';

    if(isFlowersAboveAll){
      q('gb-addon-count').textContent = 'Flower upgraded';
      grid.innerHTML = '<div class="gb-block-note">You chose flowers above all — no add-ons needed!</div>';
      return;
    }

    // Sort: selected first, then suggested, then extra
    var selected = ADDONS.filter(function(a){ return selAddons.indexOf(a.handle) > -1; });
    var unselected = ADDONS.filter(function(a){
      return selAddons.indexOf(a.handle) === -1 && a.price <= 15000;
    });
    var suggested = unselected.slice(0, 2);
    var extra = unselected.slice(2, 12);

    function makeRow(a, isExtra){
      var isSel = selAddons.indexOf(a.handle) > -1;
      var row = document.createElement('div');
      row.className = 'gb-addon-row' + (isSel ? ' sel' : '') + (isExtra ? ' gb-addon-extra' : '');

      var imgEl = document.createElement('img');
      imgEl.src = a.image; imgEl.className = 'gb-addon-row-img'; imgEl.alt = a.title;
      imgEl.onerror = function(){ this.style.display = 'none'; };

      var info = document.createElement('div'); info.className = 'gb-addon-row-info';
      var name = document.createElement('div'); name.className = 'gb-addon-row-name'; name.textContent = a.title;
      var price = document.createElement('div'); price.className = 'gb-addon-row-price'; price.textContent = centsToDisplay(a.price);
      info.appendChild(name); info.appendChild(price);

      if(isSel){
        var tag = document.createElement('div'); tag.className = 'gb-addon-row-tag'; tag.textContent = 'Suggested';
        info.appendChild(tag);
      }

      var toggle = document.createElement('button');
      toggle.className = 'gb-addon-row-toggle';
      toggle.textContent = isSel ? '−' : '+';

      (function(handle, sel){
        toggle.onclick = function(){
          if(sel){
            selAddons = selAddons.filter(function(h){ return h !== handle; });
          } else {
            selAddons.push(handle);
          }
          renderAddons();
          updateTotal();
        };
      })(a.handle, isSel);

      row.appendChild(imgEl); row.appendChild(info); row.appendChild(toggle);
      return row;
    }

    selected.forEach(function(a){ grid.appendChild(makeRow(a, false)); });
    suggested.forEach(function(a){ grid.appendChild(makeRow(a, false)); });
    extra.forEach(function(a){ grid.appendChild(makeRow(a, true)); });

    if(extra.length > 0){
      var moreWrap = document.createElement('div'); moreWrap.className = 'gb-addon-more';
      var moreBtn = document.createElement('button'); moreBtn.className = 'gb-addon-more-btn';
      moreBtn.textContent = 'See more options (' + extra.length + ')';
      moreBtn.onclick = function(){
        var extras = grid.querySelectorAll('.gb-addon-extra');
        var isOpen = extras[0] && extras[0].classList.contains('open');
        extras.forEach(function(el){ el.classList.toggle('open', !isOpen); });
        moreBtn.textContent = isOpen ? 'See more options (' + extra.length + ')' : 'Show fewer options';
      };
      moreWrap.appendChild(moreBtn);
      grid.appendChild(moreWrap);
    }

    q('gb-addon-count').textContent = selAddons.length + ' selected';
    var note = q('gb-addons-note');
    if(note) note.textContent = selAddons.length > 0 ? 'Tap − to remove, + to add more.' : 'Tap + to add an add-on.';
  }

  // ══════════════════════════════════════════════════════════════════════════
  // FLOWER SWITCHER
  // ══════════════════════════════════════════════════════════════════════════
  window.gbToggleFlowers = function(){
    var panel = q('gb-flower-options');
    if(!panel) return;
    if(panel.classList.contains('open')){
      panel.classList.remove('open');
      return;
    }
    panel.innerHTML = '';
    var occ = A['1'], budget = A['3'];
    var budgetCaps = {under100:10000, '100to150':15000, '150to200':20000, over200:999900};
    var cap = budgetCaps[budget] || 999900;

    var available = FLOWERS.filter(function(f){
      if(!f.variants || f.variants.length === 0) return false;
      if(occ === 'sympathy' && !isSympathyFlower(f)) return false;
      if(occ !== 'sympathy' && isSympathyFlower(f)) return false;
      return f.variants[0].price <= cap;
    });

    available.forEach(function(f){
      var opt = document.createElement('div');
      opt.className = 'gb-flower-opt' + (f.handle === selFlower ? ' active-flower' : '');

      var imgEl = document.createElement('img');
      imgEl.src = f.image; imgEl.className = 'gb-flower-opt-img'; imgEl.alt = f.title;
      imgEl.onerror = function(){ this.style.display = 'none'; };

      var info = document.createElement('div'); info.className = 'gb-flower-opt-info';
      var name = document.createElement('div'); name.className = 'gb-flower-opt-name'; name.textContent = f.title;
      var price = document.createElement('div'); price.className = 'gb-flower-opt-price'; price.textContent = 'From ' + centsToDisplay(f.variants[0].price);
      info.appendChild(name); info.appendChild(price);
      opt.appendChild(imgEl); opt.appendChild(info);

      opt.onclick = function(){
        selFlower = f.handle; selVariantIdx = 0;
        renderFlower(f);
        selJar = null; selJarMessage = '';
        renderJars();
        renderAddons(); updateTotal();
        panel.classList.remove('open');
      };
      panel.appendChild(opt);
    });
    panel.classList.add('open');
    panel.scrollIntoView({behavior:'smooth', block:'nearest'});
  };

  // ══════════════════════════════════════════════════════════════════════════
  // TOTAL & CART
  // ══════════════════════════════════════════════════════════════════════════
  function updateTotal(){
    var f = getFlowerByHandle(selFlower);
    if(!f) return;
    var fp = f.variants[selVariantIdx].price;
    var at = 0;
    selAddons.forEach(function(h){
      for(var i=0;i<ADDONS.length;i++){
        if(ADDONS[i].handle === h){ at += ADDONS[i].price; break; }
      }
    });
    var jp = (selJar && selJar.price) ? selJar.price : 0;
    q('gb-cart-total').textContent = centsToDisplay(fp + at + jp);
    var cnt = selAddons.length;
    var jarTxt = selJar ? ' + 1 jar' : '';
    q('gb-cart-items-txt').textContent = '1 flower' + jarTxt + ' + ' + cnt + ' add-on' + (cnt !== 1 ? 's' : '');
  }

  window.gbAddToCart = function(){
    var btn = q('gb-btn-cart'), msg = q('gb-cart-msg');

    // Validate jar personalisation if required
    if(selJar && selJar.isPersonalised){
      var jarInput = q('gb-jar-input');
      var jarMsg = jarInput ? jarInput.value.trim() : '';
      if(!jarMsg){
        msg.className = 'gb-cart-msg err';
        msg.textContent = 'Please add a message for your personalised jar.';
        jarInput.classList.add('gb-error');
        jarInput.focus();
        return;
      }
      jarInput.classList.remove('gb-error');
      selJarMessage = jarMsg;
    }

    btn.disabled = true;
    msg.className = 'gb-cart-msg'; msg.textContent = 'Adding to cart...';

    var f = getFlowerByHandle(selFlower);
    if(!f) return;
    var items = [];

    // Flower variant
    var fv = f.variants[selVariantIdx];
    if(fv && fv.id) items.push({id: fv.id, quantity: 1});

    // Jar variant (with personalisation properties if applicable)
    if(selJar && selJar.variantId){
      var jarItem = {id: selJar.variantId, quantity: 1};
      if(selJar.isPersonalised && selJarMessage){
        jarItem.properties = {message: selJarMessage};
      }
      items.push(jarItem);
    }

    // Addon variants
    selAddons.forEach(function(h){
      for(var i=0;i<ADDONS.length;i++){
        if(ADDONS[i].handle === h && ADDONS[i].variantId){
          items.push({id: ADDONS[i].variantId, quantity: 1});
          break;
        }
      }
    });

    if(!items.length){
      msg.className = 'gb-cart-msg err';
      msg.textContent = 'Could not add to cart. Please try again.';
      btn.disabled = false;
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify({items: items}),
      credentials: 'same-origin'
    })
    .then(function(res){
      if(res.ok){
        // Fire Shopify custom event for analytics tracking
        var f = getFlowerByHandle(selFlower);
        var fp = f ? f.variants[selVariantIdx].price : 0;
        var totalCents = fp + (selJar && selJar.price ? selJar.price : 0);
        selAddons.forEach(function(h){
          for(var i=0;i<ADDONS.length;i++){
            if(ADDONS[i].handle === h){ totalCents += ADDONS[i].price; break; }
          }
        });
        if(typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish){
          Shopify.analytics.publish('gift_builder_add_to_cart', {
            occasion: A['1'] || '',
            loves: Array.isArray(A['2']) ? A['2'].join(',') : (A['2'] || ''),
            budget: A['3'] || '',
            flower: selFlower || '',
            flower_title: f ? f.title : '',
            addon_count: selAddons.length,
            has_jar: selJar ? true : false,
            total_cents: totalCents,
            total: centsToDollars(totalCents)
          });
        }

        // Set cart attribute so the order is tagged as gift builder
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({attributes: {gift_builder: 'true', gift_builder_occasion: A['1'] || ''}})
        }).finally(function(){
          msg.className = 'gb-cart-msg';
          msg.textContent = 'Bundle added!';
          setTimeout(function(){ window.location.href = '/cart'; }, 400);
        });
      } else {
        throw new Error();
      }
    })
    .catch(function(){
      msg.className = 'gb-cart-msg err';
      msg.textContent = 'Something went wrong. Please try again.';
      btn.disabled = false;
    });
  };

  window.gbRestart = function(){
    Object.keys(A).forEach(function(k){ delete A[k]; });
    selFlower = null; selVariantIdx = 0; selAddons = []; selJar = null; selJarMessage = '';
    var jarBlock = q('gb-jar-block'); if(jarBlock) jarBlock.style.display = 'none';
    var jarInput = q('gb-jar-input'); if(jarInput){ jarInput.value = ''; jarInput.classList.remove('gb-error'); }
    var quoteEl = q('gb-quote'); if(quoteEl) quoteEl.innerHTML = '';
    document.querySelectorAll('.gb-step').forEach(function(s){ s.classList.remove('active'); });
    document.querySelectorAll('.gb-opt-tile,.gb-occ-card').forEach(function(b){ b.classList.remove('sel'); });
    var lc = q('gb-loves-continue'); if(lc) lc.classList.remove('on');
    q('gb-cart-msg').textContent = '';
    q('gb-btn-cart').disabled = false;
    q('gb-btn-cart').textContent = 'ADD BUNDLE TO CART';
    q('gb-s1').classList.add('active');
    setProgress(0);
    window.scrollTo(0,0);
    buildOccasionGrid();
  };

  // ── Init ──
  buildOccasionGrid();
  var ps1 = q('gb-ps1'); if(ps1) ps1.classList.add('active');

})();
